import { Box, Stack } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";
import { LoadingWrapper } from "@context-providers/loading-state-context";
import { IconButton, Menu, ThreeDotsIcon } from "@flat-ui";
import { useRef, useState } from "react";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";
/**
 * Renders bulk action buttons in a horizontal layout
 * Future enhancement: Show icon or text based on available space
 */
export function FaroTableBulkActionsButtons({
  bulkActionsButtons,
  isLoading
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const buttonRef = useRef(null);
  const buttons = Object.values(bulkActionsButtons).filter(Boolean);
  const mode = useBulkActionsMode();
  if (mode === "collapsed") {
    return <>
        <IconButton ref={buttonRef} onClick={() => setIsMenuOpen(true)} size="m" margin={0.5} color={PALETTE_VARS.common.white} hoverColor={PALETTE_VARS.common.white}>
          <ThreeDotsIcon sx={{
          transform: "rotate(90deg)"
        }} />
        </IconButton>

        {/* Keep Menu always mounted to preserve dialog state */}
        <Menu open={isMenuOpen} anchorEl={buttonRef.current} onClose={() => setIsMenuOpen(false)} minWidth="7rem" keepMounted>
          {buttons.map((button, index) => <Box key={index}>
              <LoadingWrapper isLoading={isLoading}>{button}</LoadingWrapper>
            </Box>)}
        </Menu>
      </>;
  }
  return <Stack sx={{
    flexDirection: "row",
    gap: 1.5,
    alignItems: "center"
  }}>
      {buttons.map((button_0, index_0) => <Box key={index_0}>
          <LoadingWrapper isLoading={isLoading}>{button_0}</LoadingWrapper>
        </Box>)}
    </Stack>;
}